import { Injectable } from '@angular/core';
import { Absence } from '@cl/shared/models/absences/absence.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AbsenceFilter } from '@cl/shared/models/absences/absence-filter.model';
import { BaseDownloadServiceWithFilter } from './base.service';
import { lastValueFrom, Observable } from 'rxjs';
import { CommandResult } from '@cl/shared/models/misc/command-result.model';
import { NzImageService } from 'ng-zorro-antd/image';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class AbsencesService extends BaseDownloadServiceWithFilter<Absence, AbsenceFilter> {
    constructor(
        protected httpClient: HttpClient,
        protected nzImageService: NzImageService,
    ) {
        super(httpClient, '/api/v1/absences/', nzImageService);
    }

    async getAbsencesForDashboardCalendar(filterObj: AbsenceFilter): Promise<CommandResult<Absence[]>> {
        let httpParams = new HttpParams();
        if (filterObj) {
            Object.entries(filterObj).forEach(([key, value]) => {
                if (value) {
                    httpParams = httpParams.append(key, value.toString());
                }
            });
        }

        return await lastValueFrom(this.httpClient.get<CommandResult<Absence[]>>(`${this.baseApiUrl}dashboard-calendar`, { params: httpParams }));
    }

    async exportAbsences(filterObj: AbsenceFilter): Promise<void> {
        let httpParams = new HttpParams();
        if (filterObj) {
            Object.entries(filterObj).forEach(([key, value]) => {
                if (value) {
                    httpParams = httpParams.append(key, value.toString());
                }
            });
        }
        return this.handleGeneratedFileDownload(
            lastValueFrom(
                this.httpClient.get<Blob>(`${this.baseApiUrl}export`, { params: httpParams, responseType: 'blob' as 'json', observe: 'response' }),
            ),
        );
    }

    isDateRangeOverlapping(performerId: number, startDate: string, endDate: string, absenceId: number = 0): Observable<boolean> {
        const params: HttpParams = new HttpParams()
            .set('performerId', performerId)
            .set('startDate', startDate)
            .set('endDate', endDate)
            .set('absenceId', absenceId);
        return this.httpClient.get<boolean>(`${this.baseApiUrl}date-range-overlap`, { params });
    }

    gotoLuidaisAbsence(id: number): void {
        window.open(`${environment.luidaisUrl}/ui/vacation.php?cmd=VIEW&id=${id}`, '_blank').focus();
    }
}
